<script>
  import Player from './Player.svelte';
  import { user, game } from '../store/store';
</script>

<ul class="player-list">
  {#each $game.playerSortScore as playerOb}
    <Player {playerOb} --player-color={$game.player.list[playerOb.userId].color} />
  {/each}
</ul>

<style>
  .player-list {
    display: flex;
    flex-direction: column;
    margin: 0;
    margin-top: 0em;
    padding: 0;
    /* align-self: flex-start; */
  }

@media only screen and (min-width: 1000px) {
  .player-list {
    margin-top: 1em;
  }

}
    
</style>